// useImageSelection.tsx
import { createContext, useContext, useState } from "react";

const ImageSelectionContext = createContext(null);

/**
 * ImageSelectionProvider component manages the state of selected images and animation status.
 * It provides the selected index, a function to set the selected index,
 * and a flag to indicate if an animation is in progress.
 * Components can use the `useImageSelection` hook to access the context.
 */
export function ImageSelectionProvider({ children }) {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);

  return (
    <ImageSelectionContext.Provider
      value={{ selectedIndex, setSelectedIndex, isAnimating, setIsAnimating }}
    >
      {children}
    </ImageSelectionContext.Provider>
  );
}

export const useImageSelection = () => useContext(ImageSelectionContext);
